import { AfterViewInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { InputDateAdapter } from './input-date-adapter';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@Component({
  selector: 'input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.css'],
  providers: [
    {
      provide: DateAdapter, useClass: InputDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})

export class InputDateComponent implements AfterViewInit  {

  @Input() control: FormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() minDateJson: any = {};
  @Input() maxDateJson: any = {};
  @Input() dates: Array<number> = [];
  @Input() minDate: Date = new Date();
  @Input() maxDate: Date | undefined = new Date();
  @Input() minYear: number = -1;
  @Input() maxYear: number = -1;
  @Input() startView: "month" | "year" | "multi-year" = 'month';
  @Input() messageRequired: string = 'Información requerida';
  @Input() messageFooter: string = '';

  @Output() changeValuesEvent = new EventEmitter<undefined>();

  constructor() {

    this.minDate.setHours(0, 0, 0, 0);
    this.maxDate.setHours(0, 0, 0, 0);

    this.minDate.setUTCFullYear(this.minDate.getUTCFullYear());
    this.minDateJson = { year: this.minDate.getUTCFullYear(), month: this.minDate.getUTCMonth() + 1, day: this.minDate.getDate() };
    if (this.maxDate !== undefined) {
      this.maxDate.setUTCFullYear(this.maxDate.getUTCFullYear() + 100);
      this.maxDateJson = { year: this.maxDate.getUTCFullYear(), month: this.maxDate.getUTCMonth() + 1, day: this.maxDate.getDate() };
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.control.addValidators(this.validateDate());
    }, 100);
  }

  dayFilter = (d: Date | null | undefined | any): boolean => {

    if (this.dates.length === 0)
      return true;

    const date = d !== null && d !== undefined ? d.toDate() : new Date();

    return this.dates.filter(item => item === date.getTime()).length > 0 ? true : false;

  };

  dateChangeEvent(event: MatDatepickerInputEvent<Date>) {
    this.changeValuesEvent.next(undefined);
  }

  validateDate(): ValidatorFn | ValidatorFn[] {

    return (): ValidationErrors | null => {

      if (!this.control.value)
        return null;

      const currentValue: Date = new Date(this.control.value);

      currentValue.setHours(0, 0, 0, 0);

      if (this.minYear > -1 && this.maxYear > -1) {

        if (this.maxDate !== undefined && currentValue > this.maxDate) {
          return { invalidDate: { minyear: { min: this.minYear } } };
        }

        if (currentValue < this.minDate) {
          return { invalidDate: { maxyear: { max: this.maxYear } } };
        }
        return null;

      }

      if (this.maxDate === undefined) {
        if (currentValue < this.minDate) {
          return { invalidDate: { mindate: { current: currentValue, min: this.minDate } } };
        }
      }
      else {
        if (currentValue < this.minDate || currentValue > this.maxDate) {
          return { invalidDate: { range: { current: currentValue, min: this.minDate, max: this.maxDate } } };
        }
      }
    }
  }
}